const _ = require('lodash');

// APPLICATION LOCALES
// _________________________________________________________________________//
const Application = require('../actions/application/Application.i18n.json');

// COMPONENT LOCALES
// _________________________________________________________________________//
const About = require('../components/layout/viewport/footer/about/About.i18n.json');
const ActiveSessions = require('../components/layout/viewport/footer/active_sessions/ActiveSessions.i18n.json');
const ActivityBadge = require('../components/layout/viewport/sidebar/component/ActivityBadge.i18n.json');
const ColumnMenu = require('../components/grid/columnmenu/ColumnMenu.i18n.json');
const PuzzleCheckboxMultiselect = require('../components/UI/checkbox/PuzzleCheckboxMultiselect.i18n.json');
const Dashboard = require('../components/dashboard/Dashboard.i18n.json');
const TermDashboard = require('../components/dashboard/TermDashboard.i18n.json');
const DashboardDrawer = require('../components/dashboard/DashboardDrawer.i18n.json');
const DragAndDropArea = require('../components/upload/DragAndDropArea.i18n');
const FilterCombo = require('../components/uncategorized/FilterCombo.i18n.json');
const FilterDialog = require('../components/search/filter/FilterDialog.i18n.json');
const SavedFilter = require('../components/search/filter/SavedFilter.i18n.json');
const Footer = require('../components/layout/viewport/footer/Footer.i18n.json');
const CellEllipsisExpandText = require('../components/grid/cell_renderer/CellEllipsisExpandText.i18n.json');
const CellExpandDetails = require('../components/grid/cell_renderer/CellExpandDetails.i18n.json');
const ColumnsButton = require('../components/grid/columns/ColumnsButton.i18n.json');
const ConditionalField = require('../components/filter/conditional/ConditionalField.i18n.json');
const ConditionalFilter = require('../components/filter/conditional/ConditionalFilter.i18n.json');
const Header = require('../components/layout/viewport/header/Header.i18n.json');
const LoginPage = require('../components/login_page/LoginPage.i18n.json');
const NavigationBaseGrid = require('../components/grid/NavigationBaseGrid.i18n.json');
const NavigationBaseTreeGrid = require('../components/grid/NavigationBaseTreeGrid.i18n.json');
const SearchBar = require('../components/search/SearchBar.i18n.json');
const Sidebar = require('../components/layout/viewport/sidebar/Sidebar.i18n.json');
const UploadPanel = require('../components/upload/UploadPanel.i18n');
const Viewport = require('../components/layout/viewport/Viewport.i18n.json');
const PuzzleColorPicker = require('../components/UI/fields/color_picker/PuzzleColorPicker.i18n.json');
const PuzzleDateRange = require('../components/UI/fields/date/PuzzleDateRange.i18n.json');
const PuzzleMultiselect = require('../components/UI/fields/multiselect/PuzzleMultiselect.i18n.json');
const PuzzleFindAndReplace = require('../components/UI/fields/find_and_replace/PuzzleFindAndReplace.i18n.json');
const PuzzleRemoteMenu = require('../components/layout/menu/PuzzleRemoteMenu.i18n.json');
const PuzzleRemoteListAbstract = require('../components/layout/menu/PuzzleRemoteListAbstract.i18n.json');
const PuzzleTagField = require('../components/UI/tag/PuzzleTagField.i18n.json');
const TabPanel = require('../components/tab_panel/TabPanel.i18n.json');
const TwoPanelSelector = require('../components/two_panel_selector/TwoPanelSelector.i18n.json');

// DISPATCHER LOCALES
// _________________________________________________________________________//
const ActivityWarning = require('../dispatcher/modules/warning/content/activity/ActivityWarning.i18n.json');
const Ajax = require('../dispatcher/ajax/Ajax.i18n.json');
const Content = require('../dispatcher/modules/widget/download/Content.i18n.json');
const CookiesWarning = require('../dispatcher/modules/warning/content/cookie/CookiesWarning.i18n.json');
const CustomTag = require('../dispatcher/modules/customtag/CustomTag.i18n.json');
const Dialog = require('../dispatcher/modules/dialog/Dialog.i18n.json');
const Dispatcher = require('../dispatcher/Dispatcher.i18n.json');
const DownloadWidget = require('../dispatcher/modules/widget/download/DownloadWidget.i18n.json');
const Indicator = require('../dispatcher/modules/indicator/Indicator.i18n.json');
const ProgressBar = require('../dispatcher/modules/progressbar/ProgressBar.i18n.json');
const ProgressBarHolder = require('../dispatcher/modules/progressbar/ProgressBarHolder.i18n.json');
const WarningDialog = require('../dispatcher/modules/warning/WarningDialog.i18n.json');
const Widget = require('../dispatcher/modules/widget/Widget.i18n.json');

// COMMON LOCALES
// _________________________________________________________________________//
const common = require('./Common.i18n.json'); // separated namespace for all data which is same for all apps

// TRANSLATION NAMESPACES
// should NOT contain hardcoded locales, only imported locales are allowed
// _________________________________________________________________________//
const translation = {
  About,
  ActiveSessions,
  ActivityBadge,
  ActivityWarning,
  Ajax,
  Application,
  CellEllipsisExpandText,
  CellExpandDetails,
  ColumnsButton,
  ColumnMenu,
  ConditionalField,
  ConditionalFilter,
  Content,
  CookiesWarning,
  CustomTag,
  Dashboard,
  TermDashboard,
  DashboardDrawer,
  DownloadWidget,
  DragAndDropArea,
  FilterCombo,
  FilterDialog,
  SavedFilter,
  Footer,
  Header,
  Indicator,
  LoginPage,
  NavigationBaseGrid,
  NavigationBaseTreeGrid,
  ProgressBar,
  ProgressBarHolder,
  PuzzleCheckboxMultiselect,
  PuzzleDateRange,
  PuzzleMultiselect,
  PuzzleFindAndReplace,
  PuzzleRemoteMenu,
  PuzzleTagField,
  PuzzleRemoteListAbstract,
  SearchBar,
  Sidebar,
  UploadPanel,
  Viewport,
  PuzzleColorPicker,
  Widget,
  TabPanel,
  TwoPanelSelector,
  Dialog: {
    ActivityWarning,
    CookiesWarning,
    Application,
    FilterDialog,
    Dashboard,
    ...Dialog
  },
  WarningDialog: {
    ActivityWarning,
    CookiesWarning,
    Dashboard,
    ...Dispatcher,
    ...WarningDialog
  }
};

// STORYBOOK NAMESPACE
// WHAT EVER WORKS
// should merge with common and translation namespaces
// _________________________________________________________________________//
let storybook = _.merge({
  ActivityBadge,
  ActivityWarning,
  CookiesWarning,
  PuzzleColorPicker,
  Cookie: {
    activeCookie: 'Active cookies'
  },
  ChangeLanguage: {
    currentLanguage: 'Current language'
  },
  Dialog: {
    ...Dialog,
    customTag: {
      title: 'Custom Tag Develop',
      btn1: 'BUTTON1',
      btn2: 'UPDATE BUTTONS',
      btn3: 'HIDDEN BUTTTON'
    },
    UpdateFooterWithCustomType: {
      counter: 'Counter',
      incrementValue: 'Increment value',
      save: 'Save',
      title: 'Update Footer With Custom Type'
    },
    DisableFooterWithCustomType: {
      title: 'Disable/Enable Custom Tag',
      disable: 'DISABLE',
      enable: 'ENABLE'
    },
    zIndex: {
      btn1: 'WARNING',
      btn2: 'DIALOG'
    },
    zika: {
      slika: 'pAPRIKA',
      mika: 'karakondzula'
    },
    gcc: {
      title: 'GCC Files And Folders',
      submit: 'SUBMIT'
    },
    updateDialogRenderContent: {
      title: 'Update Dialog Content Props',
      contentProps: 'UPDATE PROPS',
      all: 'UPDATE ALL'
    }
  },
  WarningDialog: {
    ...Dispatcher,
    ...WarningDialog,
    titleWarning: 'Z-INDEX-DEVELOP-WARNING',
    zIndex: {
      btn1: 'WARNING',
      btn2: 'DIALOG'
    },
    windowManager: {
      text: 'Number of opened windows is {{count}}'
    }
  },
  DownloadWidget,
  Widget: {
    ...Widget,
    WidgetDockTop: {
      updateTitle: 'Click to update title',
      open_mini_widget: 'Open Mini Widget',
      close: 'Close',
      title: 'Title'
    },
    titleWidget: 'Z-INDEX-DEVELOP-WIDGET',
    zIndex: {
      btn1: 'WARNING',
      btn2: 'DIALOG'
    }
  },
  CustomTag: {
    ...CustomTag,
    label1Txt: 'LABEL 1 ({{sBold}}{{counter}}{{eBold}})',
    label2: 'LABEL 2',
    label3Txt: '{{sBold}}LABEL 3 ({{counter}}){{eBold}}',
    label4: 'LABEL 4',
    notificationLabel: {
      text: 'Some notification text',
      text1: 'No: {{counter}}'
    },
    headerTag: {
      batch: 'Batch',
      lang: 'Languages'
    },
    story: {
      label: 'Show some message',
      counter: 'Counter has value of {{counter}}',
      notificationText: 'Notification text goes here.'
    },
    UpdateFooterWithCustomType: {
      alert: 'Before increment text',
      updated: 'After increment text'
    }
  },
  PopupWindow: {
    example: {
      title: '{{popupTitle}}'
    }
  },
  Indicator,
  NavigationBaseGrid,
  NavigationBaseTreeGrid,
  ProgressBar,
  ProgressBarHolder
}, common, translation);

// <example-locales-merge>
// EXAMPLES LOCALES
// _________________________________________________________________________//

const Asynchronous = require('../examples/dispatcher/dispatcher/ajax/asynchronous/Asynchronous.i18n.json');
const BaseModule = require('../examples/dispatcher/locales/BaseModule.i18n.json');
const Download = require('../examples/dispatcher/dispatcher/ajax/download/Download.i18n.json');
const ExtendedModule = require('../examples/dispatcher/locales/ExtendedModule.i18n.json');
const PromiseExample = require('../examples/dispatcher/dispatcher/ajax/promise/Promise.i18n.json');
const Upload = require('../examples/dispatcher/dispatcher/ajax/upload/Upload.i18n.json');
const WarningExample = require('../examples/dispatcher/dispatcher/modules/warning/WarningExamples.i18n.json');
const FormExamples = require('../examples/components/UI/form/FormExamples.i18n.json');
const FormWithValidation = require('../examples/components/UI/form/FormExamples.i18n.json');
const AllFieldExamples = require('../examples/components/UI/form/FormExamples.i18n.json');
const MiniFormWithMediumFields = require('../examples/components/UI/form/FormExamples.i18n.json');
const MultipanelFormExample = require('../examples/components/UI/form/FormExamples.i18n.json');
const OtherFields = require('../examples/components/UI/form/FormExamples.i18n.json');
const FormSecondExample = require('../examples/components/UI/form/FormExamples.i18n.json');
const FormThirdExample = require('../examples/components/UI/form/FormExamples.i18n.json');
const RadioButtonsGroup = require('../examples/components/UI/form/FormExamples.i18n.json');
const CheckBoxButtonsGroup = require('../examples/components/UI/form/FormExamples.i18n.json');
const HBoxSecondExample = require('../examples/components/UI/form/FormExamples.i18n.json');
const HBoxThirdExample = require('../examples/components/UI/form/FormExamples.i18n.json');
const HBoxFlexFormExamples = require('../examples/components/UI/form/FormExamples.i18n.json');
const Architect = require('../examples/components/architect/Architect.i18n.json');
const ArchitectForm = require('../examples/components/architect/Architect.i18n.json');
const ArchitectCodeMirror = require('../examples/components/architect/Architect.i18n.json');
const ProjectInfoForm = require('../examples/components/architect/Architect.i18n.json');
const Player = require('../examples/components/architect/Architect.i18n.json');
const General = require('../examples/components/tab_panel/tabPanelFormChildren/general/General.i18n.json');
const TMattributes = require('../examples/components/tab_panel/tabPanelFormChildren/tmAttributes/TMattributes.i18n.json');
const TmGroupAdmins = require('../examples/components/tab_panel/tabPanelFormChildren/tmGroupAdmins/TmGroupAdmins.i18n.json');
const TabPanelFormWithValidation = require('../examples/components/UI/form/TabPanelFormWithValidation.i18n.json');
const NavigationBaseEditorGridExamples = require('../examples/components/grid/NavigationBaseEditorGridExamples.i18n.json');
const PasswordInputAndCopyButtonExample = require('../examples/components/UI/form/FormExamples.i18n.json');
const PuzzleCopyButton = require('../examples/components/UI/form/FormExamples.i18n.json');
const ComboboxAllDataWithValidation = require('../examples/components/UI/fields/combo/Combobox.i18n.json');
const SapphireTabPanelTreeDashboard = require('../examples/components/dashboard/SapphireTabPanelTreeDashboard.i18n.json');
const PuzzleInputWithExistingValidationDefaultExample = require('../examples/components/UI/fields/input/PuzzleInputWithExistingValidationDefaultExample.i18n.json');
const PuzzleInputWithExistingValidationVariableErrorMessageExample = require('../examples/components/UI/fields/input/PuzzleInputWithExistingValidationVariableErrorMessageExample.i18n.json');

const examples = {
  Dialog: {
    TabPanelFormWithValidation,
    Player
  },
  WarningDialog: {
    ...WarningExample,
    ...NavigationBaseEditorGridExamples
  },
  Asynchronous,
  BaseModule,
  Download,
  ExtendedModule,
  Upload,
  FormExamples,
  FormWithValidation,
  AllFieldExamples,
  MiniFormWithMediumFields,
  MultipanelFormExample,
  OtherFields,
  FormSecondExample,
  FormThirdExample,
  RadioButtonsGroup,
  CheckBoxButtonsGroup,
  HBoxSecondExample,
  HBoxThirdExample,
  HBoxFlexFormExamples,
  Architect,
  ArchitectForm,
  ArchitectCodeMirror,
  ProjectInfoForm,
  General,
  TMattributes,
  TmGroupAdmins,
  PasswordInputAndCopyButtonExample,
  PuzzleCopyButton,
  ComboboxAllDataWithValidation,
  SapphireTabPanelTreeDashboard,
  PuzzleInputWithExistingValidationDefaultExample,
  PuzzleInputWithExistingValidationVariableErrorMessageExample,
  PromiseExample: PromiseExample
};
storybook = _.merge(storybook, examples);
// </example-locales-merge>

export default {
  storybook,
  common,
  translation
};
